import React from 'react';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import styles from './ClientTypes.module.css';

const ClientTypeList = ({ 
    clientTypes, 
    loading, 
    onEdit, 
    onDelete, 
    searchQuery,
    setSearchQuery 
}) => {
    if (loading) {
        return (
            <div className={styles.loading}>
                <div className={styles.spinner}></div>
                <p>Loading client types...</p>
            </div>
        );
    }

    if (clientTypes.length === 0 && !searchQuery) {
        return (
            <div className={styles.emptyState}>
                <h3>No Client Types Found</h3>
                <p>Create your first client type to get started.</p>
            </div>
        );
    }

    return (
        <div className={styles.listContainer}>
            {/* Table Header with Search */}
            <div className={styles.tableHeader}>
                <div className={styles.tableHeaderContent}>
                    <h3>Client Types ({clientTypes.length})</h3>
                    <div className={styles.tableFilters}>
                        <div className={styles.filterGroup}>
                            <label htmlFor="searchFilter">Search:</label>
                            <input
                                id="searchFilter"
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search by name or description..."
                                className={styles.searchInput}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.table}>
                <div className={styles.tableHead}>
                    <div className={styles.row}>
                        <div className={styles.cell}>Client Type</div>
                        <div className={styles.cell}>Description</div>
                        <div className={styles.cell}>Actions</div>
                    </div>
                </div>
                <div className={styles.tableBody}>
                    {clientTypes.length === 0 && (
                        <div className={styles.noResults}>
                            <p>No client types match your search criteria</p>
                        </div>
                    )}
                    {clientTypes.map(type => (
                        <div key={type.clientTypeId} className={styles.clientTypeRow}>
                            <div className={styles.row}>
                                <div className={styles.cell}>
                                    <div className={styles.nameCell}>
                                        <span className={styles.name}>{type.clientType}</span>
                                        <span className={styles.id}>ID: {type.clientTypeId}</span>
                                    </div>
                                </div>
                                <div className={styles.cell}>
                                    <div className={styles.description}>
                                        {type.clientTypeDescription || <span className={styles.noDescription}>No description</span>}
                                    </div>
                                </div>
                                <div className={styles.cell}>
                                    <div className={styles.actions}>
                                        <button
                                            className={styles.editButton}
                                            onClick={() => onEdit(type)}
                                            title="Edit"
                                        >
                                            <FaEdit />
                                        </button>
                                        <button
                                            className={styles.deleteButton}
                                            onClick={() => onDelete(type.clientTypeId)}
                                            title="Delete"
                                        >
                                            <FaTrashAlt />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ClientTypeList;
